module.exports = __webpack_public_path__ + "img/paper.122a4379.svg";